import { lazy, type CSSProperties, type ReactNode } from 'react';

import classNames from 'classnames';

import trophyHaloUrl from '../../../../../assets/tournament/toc/trophy-halo.svg';
import widgetBackgroundUrl from '../../../../../assets/tournament/toc/widget-background.png';
import widgetPedestalUrl from '../../../../../assets/tournament/toc/widget_pedestal.png';

import styles from './ChampionsTournamentWideWidget.module.scss';

const TrophyIcon = lazy(() => import('../../../../../components/SVGIcons/TrophyIcon'));

const cssAssetVars: CSSProperties = {
  ['--toc-wide-background' as string]: `url(${widgetBackgroundUrl})`,
  ['--toc-wide-pedestal' as string]: `url(${widgetPedestalUrl})`,
  ['--toc-wide-trophy-halo' as string]: `url(${trophyHaloUrl})`,
};

interface ChampionsTournamentWideWidgetProps {
  widgetImageUrl?: string;
  positionValue: string | null;
  startsInLabel?: string;
  timer?: ReactNode;
}

export function ChampionsTournamentWideWidget(props: ChampionsTournamentWideWidgetProps) {
  const { widgetImageUrl, positionValue, startsInLabel, timer } = props;
  const topPillText = positionValue ?? startsInLabel ?? null;
  const hasTimer = timer != null;

  return (
    <div className={styles.container} style={cssAssetVars}>
      <div className={styles.row}>
        <div className={styles.trophyBox}>
          <div aria-hidden className={styles.trophyHalo} />
          <div aria-hidden className={styles.pedestal} />
          {widgetImageUrl ? (
            <img alt="" className={styles.trophy} src={widgetImageUrl} />
          ) : (
            <TrophyIcon className={styles.trophy} />
          )}
        </div>

        <div className={styles.content}>
          {topPillText != null && (
            <div className={styles.startsInPill}>
              <span className={styles.startsInText}>{topPillText}</span>
            </div>
          )}
          {hasTimer && (
            <div className={classNames(styles.timerSlot, topPillText == null && styles.timerSlotSolo)}>{timer}</div>
          )}
        </div>
      </div>
    </div>
  );
}
